<nb-card>
  <nb-card-body>
    <div class="d-flex flex-column justify-content-center align-items-center">
      <img alt="warning" src="assets/icons/warning.png">
      <h1>{{'access-denied.title' | translate}}</h1>

      <div class="sb-card mb-3">
        <div class="card-body d-flex flex-column text-center">
          Missing permission:
          <pre *ngIf="missingRole">{{missingRole}}</pre>
        </div>
      </div>

      <button class="sb-button-white m-1" (click)="goBack()">
        <span>{{'access-denied.goBack' | translate}}</span>
      </button>
    </div>
  </nb-card-body>
</nb-card>
